import './Blog.css';
import logo from './assets/logo.png';

import {
  FaLinkedinIn,
  FaInstagram,
  FaTiktok,
} from 'react-icons/fa';


const FooterBlog = () => {
  return (
    <footer className='blog-footer'>
      <div className='blog-footer-top'>
     <a href='/blog/' className='blog-footer-brand'>
  <img src={logo} alt='ContaLearn' className='blog-footer-logo' />

 
</a>

    

       <div className='blog-footer-social'>
  <a
    href='https://www.linkedin.com/company/contalearn'
    target='_blank'
    rel='noopener noreferrer'
    aria-label='LinkedIn'
  >
    <FaLinkedinIn />
  </a>

  <a
    href='https://www.instagram.com/conta_learn'
    target='_blank'
    rel='noopener noreferrer'
    aria-label='Instagram'
  >
    <FaInstagram />
  </a>

  <a
    href='https://www.tiktok.com/@contalearn'
    target='_blank'
    rel='noopener noreferrer'
    aria-label='TikTok'
  >
    <FaTiktok />
  </a>
</div>
      </div>

      <div className='blog-footer-links'>
        <div>
          <h3>Platforma</h3>
          <a href='/'>Aplicatie</a>
          <a href='/cursuri-prezentare'>Cursuri</a>
          <a href='/registrer'>Creeaza cont</a>
        </div>

        <div>
          <h3>Resurse</h3>
          <a href='/blog/'>Articole</a>
          <a href='/faq'>Intrebari frecvente</a>
          <a href='/about'>Despre noi</a>
        </div>

        <div>
          <h3>Legal</h3>
          <a href='/termeni'>Termeni si conditii</a>
          <a href='/politica'>Politica de confidentialitate</a>
          <a href='/politicacookies'>Politica de cookie-uri</a>
          <a href='/gdpr'>Protectia datelor</a>
          <a href='/anpc'>ANPC</a>
        </div>
      </div>

      <div className='blog-footer-bottom'>
        <p>© 2026 ContaLearn. Toate drepturile rezervate.</p>
        <p>Made with ❤️ in Romania</p>
      </div>
    </footer>
  );
};

export default FooterBlog;